<template>
  <layout-component>
    <div class="banner banner-dashboard">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2 col-lg-7 offset-lg-2">
            <h1 class="left-bullet" v-html="$t('w.dashboard.title-banner')"></h1>
            <ul>
              <li><button :class="{'active': type == 'rooms'}" @click="changeType('rooms')">{{'w.dashboard.title-rooms'|t}}</button></li>
              <li><button :class="{'active': type == 'events'}" @click="changeType('events')">{{'w.dashboard.title-events'|t}}</button></li>
            </ul>

            <b-alert :show="hasError" fade variant="danger">
              <h4><i class="fal fa-times"></i> {{'w.dashboard.error-title'|t}}.</h4>
              <p v-html="$t(cancelErrorKey)"></p>
            </b-alert>

            <b-alert :show="hasRefund" fade variant="success">
              <h4><i class="fal fa-check"></i> {{'w.dashboard.refund-title'|t}}.</h4>
              <p v-html="$t('w.dashboard.refund-text')"></p>
            </b-alert>

            <template v-if="bookings && $store.rooms.content">
              <div class="select-wrapper mt-3 mt-md-4">
                <b-form-select v-model="mode" @input="changeMode()">
                  <option value="upcoming">{{'w.dashboard.upcoming-booking'|t}}</option>
                  <option value="past">{{'w.dashboard.past-booking'|t}}</option>
                </b-form-select>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!--
        Events
    -->
    <div class="container cart booking" v-if="type == 'events'">
      <template v-if="events && events.length">
        <div class="row">
          <div class="col-md-12 col-lg-10">
            <b-list-group class="cart-list booking-list">
              <template v-for="(booking,index) in events">
                <b-list-group-item class="cart-item booking-item d-md-flex align-items-md-center justify-content-md-between">
                  <div class="img-wrapper">
                    <div class="room-image" :style="`background-image:url('storage/${booking.eventCover}')`"></div>
                  </div>
                  <div class="text-wrapper d-md-flex align-items-md-start">
                    <div class="left-infos">
                      <h5>{{$i18n.locale == 'fr' ? booking.event.name : booking.event.name_en }} {{ booking.tickets > 1 ? `(x${booking.tickets})` : '' }}</h5>
                      <div class="booking-date">{{booking.date|formatDate}}</div>
                      <div class="booking-hours">{{'w.dashboard.from'|t}} {{booking.event.from | formatTimeEvent}} {{'w.dashboard.to'|t}} {{booking.event.to | formatTimeEvent}}</div>
                      <div class="booking-price" v-if="booking.price">
                        {{ booking.tickets }} x {{ booking.event.price }}€ = {{ booking.tickets * booking.event.price }} €
                      </div>
                      <div class="booking-price" v-else>{{ booking.tickets }} x {{'w.dashboard.event-free'|t}}</div>
                    </div>
                    <div class="right-infos align-self-end">
                      <ul class="links">
                        <li class="details">
                          <router-link :to="/events/+booking.event.slug" active-class="active" class="btn-link btn-link-small">
                            <span>{{'w.dashboard.event-details'|t}}</span>
                          </router-link></li>
                      </ul>
                      <ul class="links"  v-if="booking.isCancellable">
                        <li class="cancel" v-if="booking.isValidated">
                          <a href="#" class="btn-link btn-link-small" @click.prevent="openEditModal('b-edit-'+booking.id)">{{'w.dashboard.edit-booking-link'|t}}</a>
                        </li>
                        <li class="cancel" v-else>
                          <p>{{'w.dashboard.waiting-validation'|t}}</p>
                        </li>
                      </ul>
                      <ul v-if="! booking.isCancellable && mode == 'upcoming'" style="max-width: 300px;">
                        <li><p>{{'w.dashboard.no-more-cancel'|t}}</p></li>
                      </ul>
                    </div>
                  </div>
                </b-list-group-item>

                <!-- Modal Edit booking event -->
                <b-modal :id="'b-edit-'+booking.id" content-class="edit-event" ref="editEventModal" size="lg" scrollable centered hide-footer hide-header>
                  <div class="modal-booking-edit" v-show="stepEdit === 0">
                    <h3 class="left-bullet">{{'w.dashboard.edit-event'|t}}</h3>
                    <p>{{'w.dashboard.edit-event-text'|t}}</p>

                    <ul>
                      <li><b>{{'w.dashboard.edit-event-tickets'|t}}</b></li>
                      <li v-for="(ticket, index) in booking.tickets" :key="index">
                        <input type="checkbox" :id="'ticket-' + index" @change="toggleTicketSelection(index)">
                        <label :for="'ticket-' + index">Ticket {{ index + 1 }}</label>
                      </li>
                    </ul>

                    <p class="conditions">{{'w.dashboard.edit-event-conditions'|t}}</p>

                    <div class="actions">

                      <div>
                        <button class="btn" v-if="selectedTickets.length" :disabled="!selectedTickets.length" @click.prevent="stepEdit = 1">
                          <span>{{'w.dashboard.edit-event-cancel'|t}} {{ selectedTickets.length }} ticket(s)</span>
                        </button>
                      </div>

                      <a href="#" class="btn-link btn-link--small" @click.prevent="closeEventModal(booking.id)">{{'w.dashboard.close'|t}}</a>

                    </div>
                  </div>

                  <div class="modal-booking-edit" v-show="stepEdit === 1">
                    <h3 class="left-bullet">{{'w.dashboard.you-sure'|t}}</h3>
                    <p>{{'w.dashboard.confirm-edit-text'|t}} <strong>{{ selectedTickets.length }} ticket(s)</strong> {{'w.dashboard.action-undone'|t}}</p>

                    <div class="actions">

                      <div>
                        <button class="btn" v-if="selectedTickets.length" :disabled="!selectedTickets.length" @click.prevent="editEventBooking(booking.id)">
                          <span>{{'w.dashboard.yes-cancel'|t}}</span>
                        </button>
                      </div>

                      <a href="#" class="btn-link btn-link--small" @click.prevent="stepEdit = 0">
                        {{'w.dashboard.back'|t}}
                      </a>

                    </div>
                  </div>

                  <div class="modal-booking-edit" v-show="stepEdit === 2">
                    <h3 class="left-bullet">{{'w.dashboard.edit-event-done'|t}}</h3>
                    <p>{{'w.dashboard.edit-event-done-text'|t}}</p>

                    <div class="actions">

                      <a href="#" class="btn-link btn-link--small" @click.prevent="closeEventModal(booking.id)">{{'w.dashboard.close'|t}}</a>

                    </div>
                  </div>

                </b-modal>

                <b-modal :id="'b'+booking.id" ref="bookingModal" size="lg" scrollable centered hide-footer hide-header>
                  <button type="button" :aria-label="$t('w.common.close')" class="close" @click="hideModal(booking.id)"><b-img src="/storage/img/icon/icon-cross-close-modal.svg" class="cross-close-modal" width="16" height="16" /></button>

                  <div class="content">
                    <h3 class="left-bullet">{{'w.dashboard.cancel-title-01'|t}}</h3>
                    <div class="room-item d-flex align-items-center">
                      <div class="img-wrapper">
                        <div class="room-image" :style="`background-image:url('storage/${booking.eventCover}')`"></div>
                      </div>
                      <div class="text-wrapper">
                        <h5>{{booking.event.name}}</h5>
                        <div class="booking-date">{{booking.date|formatDate}}</div>
                        <div class="booking-hours">{{'w.dashboard.from'|t}} {{booking.from}}:00 {{'w.dashboard.to'|t}} {{booking.to}}:00</div>
                        <div class="booking-price">{{booking.price}} €</div>
                      </div>
                    </div>
                    <p class="refund">
                      {{'w.dashboard.cancel-text-01'|t}} <strong>{{booking.price/2}} €</strong> {{'w.dashboard.cancel-text-02'|t}}
                    </p>
                    <ul class="btn-wrapper align-items-md-end">
                      <li class="order-md-2 mb-2 mb-md-0"><b-button @click="cancelBooking(booking.id)"><span>{{'w.dashboard.cancel-btn-01'|t}}</span></b-button></li>
                      <li class="mr-md-3 order-md-1 text-center"><b-button @click="hideModal(booking.id)" class="btn-link">{{'w.dashboard.cancel-btn-02'|t}}</b-button></li>
                    </ul>
                  </div>

                </b-modal>

              </template>
            </b-list-group>
          </div>

        </div>
      </template>

      <template v-else>
        <div class="row d-md-flex justify-content-md-center pt-2 pt-md-4 pb-2 pb-md-3">
          <div class="col-md-8 col-lg-7 col-xl-6">
            <h3 class="left-bullet">{{'w.dashboard.empty-title-01'|t}}</h3>
            <p>{{'w.dashboard.empty-text-02'|t}}</p>
            <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0" to="/events" active-class="active"><span>{{'w.dashboard.book-an-event'|t}}</span></router-link>
          </div>
        </div>
      </template>
    </div>

    <!--
        Rooms
    -->
    <div class="container cart booking" v-if="type == 'rooms'">
      <template v-if="roomOrders.length">
        <div class="row">
          <div class="col-md-12 col-lg-10">
            <b-list-group class="cart-list booking-list" v-for="group in roomOrders" :key="'group-'+group.order_id">
              <template v-for="booking in group.items">
                <b-list-group-item :key="booking.id" class="cart-item booking-item d-md-flex align-items-md-center justify-content-md-between">
                  <div class="img-wrapper">
                    <div class="room-image" :style="'background-image:url('+$store.rooms.content[booking.room_id-1].images[0]+')'"></div>
                  </div>
                  <div class="text-wrapper d-md-flex align-items-md-start justify-content-md-between">
                    <div class="left-infos">
                        <h5>
                            {{$store.rooms.content[booking.room_id-1].name}}
                        </h5>
                        <div class="booking-date">
                            {{booking.date|formatDate}}
                        </div>
                        <div class="booking-hours">
                            {{'w.dashboard.from'|t}} {{booking.from}}:00 {{'w.dashboard.to'|t}} {{booking.to}}:00
                        </div>
                        <div class="booking-price">
                            {{
                                booking.balance_amount ?booking.price + booking.balance_amount : booking.price
                            }} €
                        </div>
                    </div>
                    <div class="right-infos">
                      <div class="access d-flex">
                        <simple-svg :filepath="'/storage/img/icon/icon-lock-access.svg'" />
                        <p>{{'w.dashboard.access-code-text'|t}}<br /> <span v-if="booking.code">{{booking.code}}</span><span v-else>{{'w.dashboard.to'|t}}</span></p>
                      </div>

                      <ul class="links"  v-if="booking.isCancellable">
                        <!-- <li><a href="#">{{'w.dashboard.print-link'|t}}</a></li>
                        <li><a href="#">{{'w.dashboard.room-details-link'|t}}</a></li> -->
                        <li class="cancel"><b-button v-b-modal="'b'+booking.id">{{'w.dashboard.cancel-booking-link'|t}}</b-button></li>
                      </ul>
                      <ul v-if="! booking.isCancellable && mode == 'upcoming'" style="max-width: 300px;">
                        <li><p>{{'w.dashboard.no-more-cancel'|t}}</p></li>
                      </ul>
                    </div>
                  </div>
                </b-list-group-item>
                <b-modal :id="'b'+booking.id" ref="bookingModal" size="lg" scrollable centered hide-footer hide-header>
                  <button type="button" :aria-label="$t('w.common.close')" class="close" @click="hideModal(booking.id)"><b-img src="/storage/img/icon/icon-cross-close-modal.svg" class="cross-close-modal" width="16" height="16" /></button>

                  <div class="content">
                    <h3 class="left-bullet">{{'w.dashboard.cancel-title-01'|t}}</h3>
                    <div class="room-item d-flex align-items-center">
                      <div class="img-wrapper">
                        <div class="room-image" :style="'background-image:url('+$store.rooms.content[booking.room_id-1].images[0]+')'"></div>
                      </div>
                      <div class="text-wrapper">
                        <div class="room-name">{{$store.rooms.content[booking.room_id-1].name}}</div>
                        <div class="booking-date">{{booking.date|formatDate}}</div>
                        <div class="booking-hours">{{'w.dashboard.from'|t}} {{booking.from}}:00 {{'w.dashboard.to'|t}} {{booking.to}}:00</div>
                        <!-- total paid = card price + gift-card balance portion -->
                        <div class="booking-price">{{booking.price + (booking.balance_amount || 0)}} €</div>
                      </div>
                    </div>
                    <p class="refund">
                      {{'w.dashboard.cancel-text-01'|t}} <strong>{{(booking.price + (booking.balance_amount || 0)) / 2}} €</strong> {{'w.dashboard.cancel-text-02'|t}}
                    </p>
                    <ul class="btn-wrapper align-items-md-end">
                      <li class="order-md-2 mb-2 mb-md-0"><b-button @click="cancelBooking(booking.id)"><span>{{'w.dashboard.cancel-btn-01'|t}}</span></b-button></li>
                      <li class="mr-md-3 order-md-1 text-center"><b-button @click="hideModal(booking.id)" class="btn-link">{{'w.dashboard.cancel-btn-02'|t}}</b-button></li>
                    </ul>
                  </div>

                </b-modal>
              </template>

            </b-list-group>
          </div>

        </div>
      </template>
      <template v-else>
        <div class="row d-md-flex justify-content-md-center pb-2 pb-md-3">
          <div class="col-md-8 col-lg-7 col-xl-6">
            <h3 class="left-bullet">{{'w.dashboard.empty-title-01'|t}}</h3>
            <p>{{'w.dashboard.empty-text-01'|t}}</p>
            <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0" to="/book" active-class="active"><span>{{'w.dashboard.book-a-room'|t}}</span></router-link>
          </div>
        </div>
      </template>
    </div>
	</layout-component>
</template>

<script>
  export default {
    data() {
      return {
        bookings: null,
        bookingsData: null,
        all: null,
        hasError: false,
        hasRefund: false,
        mode: 'upcoming',
        type: 'rooms',
        selectedTickets: [],
        cancelling: false,
        cancelErrorKey: 'w.dashboard.error-text',
        stepEdit: 0
      }
    },
    methods: {
      setData(data) {
        this.bookingsData = data
        this.bookings = this.bookingsData.upcoming
        this.all = this.bookingsData.all
      },
      // Cancel a single booking.
      cancelBooking(bookingId) {
        if (this.cancelling) return
        this.cancelling = true
        this.$bvModal.hide('b' + bookingId)
        Vue.axios.delete('/booking/' + bookingId)
          .then(() => this.refreshAfterCancel())
          .catch(err => this.showCancelError(err))
      },
      refreshAfterCancel() {
        Vue.axios.get('/booking').then(({ data }) => {
          // Refresh every view: changeMode rebuilds `bookings`, but `all` feeds the Events tab too.
          this.bookingsData = data
          this.all = data.all
          this.changeMode()
          this.cancelling = false
          this.hasRefund = true
          this.hasError = false
          setTimeout(function () {
            animateScrollTo(document.querySelector('.alert'), { offset: -100, passive: true })
          }, 50)
        }).catch(() => { this.cancelling = false })
      },
      showCancelError(err) {
        this.cancelling = false
        const code = err && err.response && err.response.data && err.response.data.message
        this.cancelErrorKey = code === 'not_cancellable' ? 'w.dashboard.error-window' : 'w.dashboard.error-text'
        this.hasRefund = false
        this.hasError = true
        setTimeout(function () {
          animateScrollTo(document.querySelector('.alert'), { offset: -100, passive: true })
        }, 50)
      },
      toggleTicketSelection(index) {
        const idx = this.selectedTickets.indexOf(index);
        if (idx === -1) {
          this.selectedTickets.push(index);
        } else {
          this.selectedTickets.splice(idx, 1);
        }
      },
      openEditModal(id) {
        this.selectedTickets = [];
        this.stepEdit = 0;
        this.$bvModal.show(id);
      },
      confirmEventEdit(bookingId) {
        this.$bvModal.hide('b-edit-'+bookingId);
      },
      editEventBooking(bookingId) {
        Vue.axios.put(`/booking/${bookingId}`, {
          tickets: this.selectedTickets.length,
        })
        .then(response => {
          this.stepEdit = 2;

          Vue.axios.get('/booking').then( ({data}) => {
            this.setData(data)
          });

        })
        .catch(error => {
          // Gérer l'erreur
        });
      },
      closeEventModal(bookingId) {
        this.$bvModal.hide('b-edit-'+bookingId);
        this.selectedTickets = [];
        this.stepEdit = 0;
      },
      hideModal(bookingId) {
        this.$bvModal.hide('b' + bookingId)
      },
      changeMode() {
        if(this.mode == 'past') this.bookings = this.bookingsData.past
        else this.bookings = this.bookingsData.upcoming
      },
      changeType(param) {
        this.type = param;
      }
    },

    computed: {
      events() {
        if (this.all) {
          if(this.mode == 'upcoming') {
            return this.all.filter(function (item) {
              if (item.event_id && moment().isBefore(moment(item.date))) {
                return true;
              }

              return false;
            });
          }

          return this.all.filter(item => item.event_id && moment().isAfter(moment(item.date)));
        }
      },
      rooms() {
        if (this.all) {
          return this.all.filter(item => item.room_id);
        }
      },
      // Room bookings of the current list grouped by order, for batch / whole-order cancel.
      roomOrders() {
        if (!this.bookings || !this.$store.rooms.content) return []
        const groups = {}
        this.bookings.forEach(booking => {
          if (!booking.room_id || !this.$store.rooms.content[booking.room_id - 1]) return
          if (!groups[booking.order_id]) {
            groups[booking.order_id] = { order_id: booking.order_id, items: [] }
          }
          groups[booking.order_id].items.push(booking)
        })
        return Object.values(groups)
      }
    },
    beforeRouteEnter(to, from, next) {
      Vue.axios.get('/booking').then( ({data}) => {
        next(vm => vm.setData(data))
      }).catch(() => next()); // l'API échoue → on n'empêche pas la navigation (sinon route bloquée)
    }
  }
</script>
